import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import _imports_0 from '../assets/page-image/cyds/banner.png';
const _hoisted_1 = {
  class: "cyds-detail-wrapper"
};
const _hoisted_2 = {
  class: "cyds-detail-page"
};
const _hoisted_3 = {
  key: 0,
  class: "loading-wrapper"
};
const _hoisted_4 = {
  key: 1,
  class: "detail-content"
};
const _hoisted_5 = {
  class: "mentor-name"
};
const _hoisted_6 = {
  class: "mentor-photo"
};
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = {
  class: "mentor-info-section"
};
const _hoisted_9 = {
  key: 0,
  class: "info-item"
};
const _hoisted_10 = {
  key: 2,
  class: "empty-wrapper"
};
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { getMentorById } from '@/api/mentor';
export default /*@__PURE__*/_defineComponent({
  __name: 'CydsDetail',
  setup(__props) {
    const route = useRoute();
    // 导师详情
    const mentorDetail = ref(null);
    // 加载状态
    const loading = ref(true);
    // 获取导师详情
    const fetchMentorDetail = async id => {
      try {
        loading.value = true;
        const res = await getMentorById(id);
        if (res.data) {
          mentorDetail.value = res.data;
        }
      } catch (error) {
        console.error('获取导师详情失败:', error);
      } finally {
        loading.value = false;
      }
    };
    // 页面加载时获取数据
    onMounted(() => {
      const id = route.params.id;
      if (id) {
        fetchMentorDetail(Number(id));
      }
    });
    return (_ctx, _cache) => {
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "创业导师"
      })])], -1)), _createElementVNode("div", _hoisted_2, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "loading-text"
      }, "加载中...", -1)]))])) : mentorDetail.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(mentorDetail.value.name), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
        src: mentorDetail.value.url || '../assets/page-image/cyds/daoshi1.png',
        alt: mentorDetail.value.name
      }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [mentorDetail.value.practicalExperience ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("p", null, _toDisplayString(mentorDetail.value.practicalExperience), 1)])) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
        class: "empty-text"
      }, "暂无导师详情", -1)]))]))]), _createVNode(_component_Footer)]);
    };
  }
});